export default __webpack_public_path__ + "static/1190-6c8be6f3f08626b94b3069e613d8cfaa.gif";